<!doctype html>

<header style="max-width:100%;">
  <div class="row mx-2">

    <div class="col-lg-7 col-xl-7 container-logo-home">
      <div>   
         <a routerLink="/home"><i class="fas fa-home" style="margin-right: 10px;"></i>Home</a>
      </div>
 
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
      <nav class="nav-style">
        <!--
          1 ancla
        -->
        <a class="nav-link" routerLink="/about">About</a>
      
        <!--
          2 ancla
        -->
        <ul class="nav ul-more-option justify-content-end " >
          <li class="nav-item">
            <a class="nav-link active" routerLink="/project">Projects</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">more</a>
            <div class="dropdown-menu">
              <a class="dropdown-item" routerLink="/home">Home</a>
              <a class="dropdown-item" routerLink="/skill">Skill</a>
              <a class="dropdown-item" routerLink="/contact">Contact</a>
              
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</header>


